import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';
import { memoize } from 'lodash';
import { vodContent as vodContentSchema } from 'app-webtech-core/schemas';

const resultSelector = (state) => state.vodContent.result;
const entitiesSelector = (state) => state.vodContent.entities;
const idFromProps = (_, { id }) => id;

const resolver = (id, schema, entities) => {
  const { page, pagesEnded } = entities.vodCategories[id];
  return `${id}|${page}|${pagesEnded}`;
};

const memoizedDenormalize = memoize(denormalize, resolver);

export const makeVodContentCategorySelector = () =>
  createSelector([resultSelector, entitiesSelector, idFromProps], (result, entities, id) =>
    entities.vodCategories &&
    id &&
    result.includes(id) &&
    Object.prototype.hasOwnProperty.call(entities.vodCategories, id)
      ? memoizedDenormalize(id, vodContentSchema.VodCategorySchema, entities)
      : null,
  );
